import React from 'react';

const WhatSetsApartSection = ({ title, description, apartData }) => {


    return (
        <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden text-left">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                <div className="mb-[30px] lg:mb-[60px]">
                    <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600]">
                        {title}
                    </h2>
                    <p className="text-[#49577A] font-graphik text-[14px] lg:text-[16px] font-[500] mt-2 max-w-[850px] leading-relaxed">
                        {description}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8">
                    {apartData.map((item) => (
                        <div
                            key={item.id}
                            className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex flex-col justify-center overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm"
                        >
                            <div className="relative z-10">
                                <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                    {item.title}
                                </h3>
                                <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                                    {item.desc}
                                </p>
                            </div>
                            <div className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100">
                                <img
                                    src="/assets/career/wrap1.svg"
                                    alt=""
                                    className="w-full h-full object-contain object-bottom-right"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhatSetsApartSection;